import { forwardRef, useEffect, useState } from 'react';
import { Box } from '../Box';
import { Tooltip, TooltipProps } from './Tooltip';

type ElementType = Element | null | undefined;

const textHasOverflow = (targetElement: ElementType): boolean => {
  return targetElement ? targetElement.scrollWidth > targetElement.clientWidth : false;
};

type OverflowTooltipProps = TooltipProps & {
  getTargetElement: () => ElementType;
};

export const OverflowTooltip = forwardRef<HTMLDivElement, OverflowTooltipProps>(function OverflowTooltip(
  { children, getTargetElement, ...rest },
  ref
) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasOverflow, setHasOverflow] = useState<boolean>(false);

  useEffect(() => {
    const targetElement = getTargetElement();
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setHasOverflow(textHasOverflow(targetElement));
  }, [getTargetElement]);

  if (!hasOverflow) {
    return <>{children}</>;
  }

  const handleTooltipOpen = () => {
    setIsOpen(true);
  };

  const handleTooltipClose = () => {
    setIsOpen(false);
  };

  return (
    <Tooltip open={isOpen} {...rest} ref={ref}>
      <Box onMouseEnter={handleTooltipOpen} onMouseLeave={handleTooltipClose}>
        {children}
      </Box>
    </Tooltip>
  );
});
